var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-mail';
                    var viewUrl = 'sprite.svg#view-icon-mail';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 28 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };